import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DossierService} from "../../../../services";
import {DossierBasePageComponent} from "../dossierBasePage.component";
import {IDossierSubService} from "../IDossierSub.service";
import {SvedVPRDossierService} from "./svedVPRDossier.service";
import {
  AlertPanelComponent,
  AlertPanelService,
  ITable,
  ITableCallBack,
  ITableItemDescriptor,
  TableSelectableComponent
} from "@amlCore/components";
import {DictionaryService, UserService} from "@amlCore/services";
import {SvedVPRType} from "../../../../models/dossier";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FileSaverService} from "ngx-filesaver";
import { VprInfoComponent } from './../components/vprInfo/vprInfo.component';

@Component({
  selector: 'app-sved-vpr-dossier',
  styleUrls: ['../dossier.css'],
  templateUrl: './svedVPRDossier.component.html'
})
export class SvedVPRDossierComponent extends DossierBasePageComponent implements OnInit, ITable {

  modelPage: any;
  itemDescriptor: ITableItemDescriptor;
  isTableTab = true;
  @ViewChild('tableComp', {static: true}) tableComp: TableSelectableComponent;
  @ViewChild('alertObjSave') alertObjToSave: AlertPanelComponent;

  constructor(protected dossierService: DossierService,
              protected route: ActivatedRoute,
              private svedVPRDossierService: SvedVPRDossierService,
              protected dictSrv: DictionaryService,
              protected router: Router,
              protected userService: UserService,
              protected alertPanelSrv: AlertPanelService,
              protected modalService: NgbModal,
              protected fSaver: FileSaverService) {
    super(dossierService, route, dictSrv, router, userService, alertPanelSrv, modalService, fSaver);
  }

  ngOnInit() {
    // Инициализация вкладки
    this.modelPage = this.initPage();
    // Описание элемента таблицы
    this.itemDescriptor = {
      create: this.svedVPRDossierService.getSvedVPR.bind(this.svedVPRDossierService, this.modelPage),
      component: VprInfoComponent,
      params: {
        typePage: this.typePage,
        titlePanel: 'Сведения о выгодоприобретателе',
        clientType: () => this.clientType,
      }
    } as ITableItemDescriptor;
  }

  getService(): IDossierSubService {
    return this.svedVPRDossierService;
  }

  callbackItemClosed(event: ITableCallBack) {
    this.saveTableItem(event);
  }

  onSelectChange(): void {
    this.canPrintDossier(this.tableComp.getSelectedModel() as SvedVPRType[]);
  }

  onPrintClick() : void {
    this.uploadPrintForm(this.tableComp.getSelectedModel() as SvedVPRType[], this.alertObjToSave);
  }


  destroy() {
    // ТУТ писать реализацию ngOnDestroy для компонента

  }

}
